module.exports = __webpack_public_path__ + "static/media/factory.8c9376ad.png";